module.exports = __webpack_public_path__ + "img/img_slide_tit.bbfb6110.svg";